// Animated 3-bar Airgent logo. Pyramid silhouette LOCKED (50/80/100 widths).
// Brightness pulses through bars top → middle → bottom.
// CSS in landing.css under .airgent-logo.

export default function AirgentLogo({ size = 32 }: { size?: number }) {
  return (
    <span
      className="airgent-logo"
      style={{ width: size, height: size, gap: Math.max(2, size * 0.10) }}
      aria-label="Airgent"
    >
      <span className="logo-bar logo-bar-1" />
      <span className="logo-bar logo-bar-2" />
      <span className="logo-bar logo-bar-3" />
    </span>
  );
}
